import { APCard, APColumn, APExpanded, APFormFieldImage, APFormFieldText, APIcon, APPalette, APRow, APSizedBox, APText, APTypography, Deferred, getIt, JourneyStepApp, launchDialog, showAlertSnackBarConfirmation } from 'ap-components';
import React, { useState } from 'react'
import showAPAlertSnackBar from 'ap-components/src/dialogs/showAPAlertSnackBar';
import { EmpanelmentData } from '.';
import EmpanelmentService from '../../Services/EmpanelmentService';
import { launchPage, LOCALE_REGEX } from '../../Common/Utils';
import AdminModel from '../../Models/AdminModel';
import { PennyDropDialog } from './PennyDropDialog';
import { SuccessPageDialog } from './SuccessPageDialog';
import SharedPrefs from '../../Services/SharedPrefs';



export default function BankDetails({ empanelmentData, updateEmpanelmentData }: { empanelmentData: Partial<EmpanelmentData>, updateEmpanelmentData: (data: Partial<EmpanelmentData>) => void }): JourneyStepApp {
    const [form] = useState({
        accountNumber: "",
        reAccountNumber: '',
        ifsc: '',
    })

    const [key, setKey] = useState("bank-details");
    const [branch, setBranch] = useState('');
    const [bankName, setBankName] = useState('');
    const [checkPennyDropStatus, setCheckPennyDropStatus] = useState<boolean>();
    const [bankProof, setBankProof] = useState<string>();

    return ({
        title: "Bank Details",
        code: 'Bank Details',
        description: "Next: Customisation",
        form: ((
            <APColumn key={key} mainAxisAlignment='center' crossAxisAlignment='stretch' mainAxisSize='max'>
                <APText style={APTypography.h1}>Bank Details</APText>
                <APText style={APTypography['paragraph-medium']}>Your Brokerage will be credited to this account.</APText>
                <APSizedBox height='8px' />
                <APFormFieldText
                    maxLength={30}
                    label='Account Number'
                    obscureText
                    keyboardType='tel'
                    onChanged={(v) => {
                        form.accountNumber = v;
                    }}
                    helperText="Non-individuals must provide their current account details."
                    validator={(v) => {
                        if (!/^[0-9]*$/.test(v)) {
                            return "Only numbers allowed";
                        }
                        if (v.length === 0)
                            return "Please enter Account Number";

                        if (!LOCALE_REGEX.ACCOUNT_NUMBER.test(v))
                            return 'Invalid Account Number'

                        return null;
                    }}
                />

                <APFormFieldText
                    maxLength={30}
                    obscureText
                    label='Re-enter Account Number'
                    keyboardType='tel'
                    onChanged={(v) => {
                        form.reAccountNumber = v;
                    }}
                    validator={(v) => {
                        if (!/^[0-9]*$/.test(v)) {
                            return "Only numbers allowed";
                        }
                        if (v.length === 0) {
                            return "Please enter A/C Number";
                        }
                        if (form.accountNumber !== v) {
                            return 'Account Number mismatch'
                        }
                        return null
                    }}
                ></APFormFieldText>

                <APFormFieldText
                    maxLength={30}
                    label='IFSC'
                    textAppearance='uppercase'
                    helperText={bankName ? `${bankName}, ${branch}` : ""}
                    onChanged={async (v) => {
                        form.ifsc = v;

                        if (v.length > 5) {
                            if (LOCALE_REGEX.IFSC.test(v)) {
                                try {
                                const response = await getIt(EmpanelmentService).checkIFSC(v.trim())
                                setBankName(response.BANK)
                                setBranch(response.BRANCH)
                            } catch (e) {
                                setBankName("")
                                setBranch("")
                                return "Re-check IFSC"
                            }
                            }
                            else {
                                setBankName("")
                                setBranch("")
                            }
                        }
                    }}
                    validator={async (v) => {
                        if (!/^[a-zA-Z0-9]*$/.test(v)) {
                            return "Only alphanumeric characters allowed";
                        }   

                        if (!LOCALE_REGEX.IFSC.test(v)) {
                            return 'Invalid IFSC'
                        }

                        if (LOCALE_REGEX.IFSC.test(v)) {
                            try {
                                const response = await getIt(EmpanelmentService).checkIFSC(v.trim())
                                setBankName(response.BANK)
                                setBranch(response.BRANCH)
                            } catch (e) {
                                setBankName("")
                                setBranch("")
                                return "Re-check IFSC"
                            }
                        }

                        return null
                    }}
                ></APFormFieldText>
                <APSizedBox height='16px' />
                {
                    checkPennyDropStatus === false &&
                    <>
                        <APCard padding='12px' style={{ backgroundColor: `${APPalette['warning-100']}`, width: '100%', borderRadius: '0px', borderColor: `${APPalette['warning-100']}` }}>
                            <APRow mainAxisAlignment='start' crossAxisAlignment='center'>
                                <APIcon icon='warning' color={APPalette['warning-300']} />
                                <APSizedBox width='8px' />
                                <APExpanded>
                                    <APText style={APTypography['paragraph-small']}>We couldn't verify your account. Please update your bank details or attach a bank proof below to proceed.</APText>
                                </APExpanded>
                            </APRow>
                        </APCard>
                        <APSizedBox height='16px' />
                        <APRow crossAxisAlignment="center">
                            <APText style={APTypography.h2}>Bank Proof</APText>
                            <APText style={{ color: `${APPalette['negative-300']}` }}>*</APText>
                        </APRow>
                        <APRow crossAxisAlignment="center" mainAxisAlignment="start" style={{ flexWrap: "nowrap" }}>
                            <APText style={APTypography['paragraph-small']}>
                                {"(Canceled Cheque "}
                                <span style={{ color: APPalette['brand-300'] }}>{"(Preferred) "}</span>
                                {"/Passbook/Past 1 month bank statement)"}
                            </APText>
                        </APRow>
                        <APFormFieldImage
                            label="Bank Proof"
                            onChange={setBankProof}
                            validator={(value) => {
                                if (!value || value.length === 0) {
                                    return "Bank Proof required"
                                }
                                return null;
                            }}
                        />
                        <APExpanded>
                            <APText style={APTypography['paragraph-small']}>Note:  Please ensure Account number, Account holder's name, IFSC and bank account type are clearly visible on bank proof.</APText>
                        </APExpanded>

                    </>
                    // : <APCard padding='12px' style={{ backgroundColor: '#D5E0F24D', width: '520px', borderRadius: '8px' }}>
                    //     <APColumn mainAxisAlignment='start'>
                    //         <APRow mainAxisAlignment='start'>
                    //             <div style={{ borderRadius: '100%', backgroundColor: APPalette['brand-100'], padding: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                    //                 <APIcon icon='lightbulbLine' size={20} color={APPalette['brand-300']} />
                    //             </div>
                    //             <APSizedBox width='8px' />
                    //             <APText style={APTypography.h2}>Here's where to find it:</APText>
                    //         </APRow>
                    //         <APSizedBox height='8px' />
                    //         <div style={{ margin: '0px 0px 0px 30px' }}>{
                    //             ReactHtmlParser(marked(
                    //                 `- **Account Number:** Check your passbook, bank statement, or banking app/portal.\n- **IFSC Code:** Find it on your cheque book, passbook, or bank app/website.`
                    //             ))
                    //         }</div>
                    //     </APColumn>
                    // </APCard>
                }
                <APSizedBox height='16px' />
            </APColumn>
        )),
        onSubmit: async () => {
            if (!bankProof) {
                const response = await launchDialog<{ retry?: boolean, admin?: AdminModel, token?: string, failedDrop?: boolean, manual?: boolean }>((deferred) => <PennyDropDialog deferred={deferred} accountNumber={form.accountNumber} ifsc={form.ifsc} bankProof={bankProof} />)
                if (response.retry) {
                    //if retry then reset form values
                    setKey(prev => prev + 1);
                    throw new Error("Please click on Submit to verify bank details.");
                }
                if (response.failedDrop) {
                    setCheckPennyDropStatus(false);
                    throw new Error("Please Upload the proof of your Bank Account");
                }

                if (response.manual) {
                    // @ts-ignore
                    window.flutter_inappwebview?.callHandler("manualEmpanelment");
                }

                if (response.admin) {
                    showAPAlertSnackBar({ content: "Your bank has been successfully verified.", intent: "positive", emphasis: "intense" });
                    const encodedAdminData = encodeURIComponent(JSON.stringify(response.admin));
                    getIt(SharedPrefs).removeItem('poToken');
                    // @ts-ignore
                    window.flutter_inappwebview?.callHandler("empanelmentSuccess", { appToken: response.token, adminData: encodedAdminData });
                }

            } else {
                try {
                    const response = await getIt(EmpanelmentService).saveBankDetailsv2({ accountNumber: form.accountNumber, ifsc: form.ifsc, bankImageBase64: bankProof });
                    showAPAlertSnackBar({ content: "Your bank has been successfully verified.", intent: "positive", emphasis: "intense" });
                    const encodedAdminData = encodeURIComponent(JSON.stringify(response.admin));
                    getIt(SharedPrefs).removeItem('poToken');
                    // @ts-ignore
                    window.flutter_inappwebview?.callHandler("empanelmentSuccess", { appToken: response.token, adminData: encodedAdminData });
                } catch (err: any) {
                    const metaData = err?.response?.data.metaData;
                    if (!!metaData) {
                        if (metaData.invalidSignup) {
                            launchPage('/signup/verification');
                        } else if (metaData.manual) {
                            // @ts-ignore
                            window.flutter_inappwebview?.callHandler("manualEmpanelment");
                        }
                    }
                    else {
                        throw err;
                    }
                }

            }
        }
    });
}






